// components/HomeBanner2.jsx
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner8 from "../assets/banner4.jpg";
import { FaArrowRight, FaStarAndCrescent, FaCheckCircle } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import { FaAffiliatetheme } from "react-icons/fa6";

export default function HomeBanner2() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  // Process steps data for top cards
  const processSteps = [
    {
      title: "STRATEGIZE",
      desc: "Craft tailored strategies for sustainable growth and competitive advantage.",
      img: banner8,
      accent: "from-blue-500/20 to-indigo-500/10",
      borderColor: "border-blue-500/30",
      iconColor: "#60a5fa"
    },
    {
      title: "EXECUTE",
      desc: "Flawless implementation with precision and industry best practices.",
      img: banner2,
      accent: "from-emerald-500/20 to-teal-500/10",
      borderColor: "border-emerald-500/30",
      iconColor: "#10b981"
    },
    {
      title: "TRANSFORM",
      desc: "Drive business transformation and achieve measurable excellence.",
      img: banner3,
      accent: "from-violet-500/20 to-purple-500/10",
      borderColor: "border-violet-500/30",
      iconColor: "#a78bfa"
    }
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section 
      className="MainBodySection p-2 p-md-5 py-5" 
      style={{ 
        background: "linear-gradient(45deg, #eaeef3 0%, #00205c 100%)",
        position: "relative"
      }}
    >
      <div className="container">
        
        {/* ================= PROCESS CARDS ================= */}
        <div className="row g-4 mb-5">
          {processSteps.map((step, idx) => (
            <div className="col-md-4" key={idx}>
              <div 
                className="h-100 rounded-3 border overflow-hidden position-relative"
                style={{
                  background: "white",
                  borderColor: "rgba(0,0,0,0.05)",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                  transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)";
                  e.currentTarget.style.borderColor = step.iconColor + "66";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
                  e.currentTarget.style.borderColor = "rgba(0,0,0,0.05)";
                }}
              >
                {/* Image Section */}
                <div className="position-relative" style={{ height: "220px", overflow: "hidden" }}>
                  <img 
                    src={step.img} 
                    alt={step.title} 
                    className="w-100 h-100" 
                    style={{ objectFit: "cover", transition: "transform 0.5s ease" }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                  />
                  {/* Gradient Overlay */}
                  <div className={`position-absolute top-0 start-0 w-100 h-100 opacity-20`} 
                    style={{ background: `linear-gradient(135deg, ${step.accent.split(' ')[0]}, ${step.accent.split(' ')[1]})` }} 
                  />
                </div>

                {/* Content Section */}
                <div className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <FaCheckCircle size={20} style={{ color: step.iconColor }} />
                    <h5 className="fw-bold mb-0" style={{ fontSize: "1.25rem", color: "#1e293b" }}>
                      {step.title}
                    </h5>
                  </div>
                  <p className="text-muted mb-0" style={{ lineHeight: "1.6", fontSize: "0.95rem" }}>
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* ================= MAIN CONTENT (Text + Carousel) ================= */}
        <div className="row align-items-center g-5 py-4">
          
          {/* Text Content */}
          <div className="col-lg-7">
            <span className="badge rounded-pill px-3 py-2 mb-3" 
              style={{ 
                background: "rgba(208, 221, 217, 0.11)", 
                color: "#ffffff", 
                fontWeight: "600", 
                fontSize: "22px",
                border: "1px solid rgba(117, 146, 136, 0.2)"
              }}>
              About ATRIC
            </span>
            <h2 
              className="font-bold mb-4 text-primary" 
              style={{ 
                fontSize: "clamp(2rem, 4vw, 2.75rem)", 
                lineHeight: "1.2",
                letterSpacing: "-0.5px"
              }}
            >
              ATRIC Business Consulting Limited
            </h2>
            <p className="text-muted mb-4" style={{ fontSize: "1.1rem", lineHeight: "1.7" }}>
              ATRIC Business Consulting Limited is a professional consulting firm offering 
              <strong> Management Accounting, Taxation, Internal Audit, Project Management, 
              and Financial Management services</strong> to businesses across Tanzania.
            </p>
            <p className="text-muted mb-5" style={{ fontSize: "1.1rem", lineHeight: "1.7" }}>
              Our experienced team delivers quality and timely professional services while 
              upholding the highest standards of integrity and professionalism.
            </p>

            <div className="d-flex flex-wrap gap-3">
              <button 
                className="btn btn-lg px-5 py-3 rounded-pill d-flex align-items-center gap-2"
                onClick={() => appContext.navTo({ item: "services" })}
                style={{ 
                  background: "linear-gradient(135deg, #052096, #1045b9)",
                  border: "none",
                  fontWeight: "600",
                  color: "white",
                  boxShadow: "0 4px 14px rgba(22, 27, 26, 0.35)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 20px rgba(46, 52, 70, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 14px rgba(33, 35, 71, 0.35)";
                }}
              >
                Our Services <FaArrowRight size={20} />
              </button>
              
              
            </div>
          </div>

          {/* Carousel Content */}
          <div className="col-lg-5">
            <div 
              id="profileCarousel" 
              className="carousel slide shadow-lg rounded-4 overflow-hidden" 
              data-bs-ride="carousel"
              style={{ border: "1px solid rgba(0,0,0,0.05)" }}
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={banner8} className="d-block w-100" alt="Advisory meeting" style={{ height: '350px', objectFit: 'cover' }} />
                  <div className="carousel-caption d-none d-md-block" style={{ background: "rgba(0,0,0,0.6)", borderRadius: "8px", padding: "10px" }}>
                    <p className="small mb-0">Strategic Advisory</p>
                  </div>
                </div>
                <div className="carousel-item">
                  <img src={banner2} className="d-block w-100" alt="Financial planning" style={{ height: '350px', objectFit: 'cover' }} />
                  <div className="carousel-caption d-none d-md-block" style={{ background: "rgba(0,0,0,0.6)", borderRadius: "8px", padding: "10px" }}>
                    <p className="small mb-0">Financial Excellence</p>
                  </div>
                </div>
                <div className="carousel-item">
                  <img src={banner3} className="d-block w-100" alt="Corporate strategy" style={{ height: '350px', objectFit: 'cover' }} />
                  <div className="carousel-caption d-none d-md-block" style={{ background: "rgba(0,0,0,0.6)", borderRadius: "8px", padding: "10px" }}>
                    <p className="small mb-0">Business Transformation</p>
                  </div>
                </div>
              </div>
              
              {/* Custom Styled Controls */}
              <button className="carousel-control-prev" type="button" data-bs-target="#profileCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true" style={{ filter: "invert(1) grayscale(100%) brightness(200%)" }}></span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#profileCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true" style={{ filter: "invert(1) grayscale(100%) brightness(200%)" }}></span>
              </button>
            </div>
          </div>
        </div>

        {/* ================= TRUST BADGE / FOOTER ================= */}
        <div className="text-center mt-5 pt-4 border-top" style={{ borderColor: "rgba(0,0,0,0.05)" }}>
          <div 
            className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded"
            style={{ background: "rgba(255,255,255,0.6)", backdropFilter: "blur(4px)" }}
          >
            <FaAffiliatetheme className="text-primary flex-shrink-0" size={18} /> 
            <p className="fs-6 text-muted mb-0 fw-medium">
              Committed to delivering quality and timely professional services with integrity.
            </p>
          </div>
        </div>
      </div>

      {/* ================= CSS UTILITIES ================= */}
      <style>{`

        .hb2-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #93abc7 0%, #4f81ec 60%, #f8fbff 100%);
        }

        @media (prefers-reduced-motion: reduce) {
          * { transition: none !important; animation: none !important; }
        }
        .carousel-control-prev-icon,
        .carousel-control-next-icon {
          filter: invert(1) grayscale(100%) brightness(200%);
        }
      `}</style>
    </section>
  );
}